import React, { useEffect, useState } from "react";

// style
import Style from "../NewEmploymentPositions.module.css";

const Position = ({ positionProp, setNewPositionsProp, formatNumber }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedPosition, setEditedPosition] = useState({ ...positionProp });

  const removePosition = () => {
    setNewPositionsProp((prevPositions) =>
      prevPositions.filter((pos) => pos !== positionProp)
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedPosition({
      ...editedPosition,
      [name]:
        name === "positionSalary" ||
        name === "positionPercentage" ||
        name === "expectedWorkTimeDurationInMonths"
          ? Number(value)
          : value,
    });
  };

  const saveChanges = () => {
    setNewPositionsProp((prevPositions) =>
      prevPositions.map((pos) => (pos === positionProp ? editedPosition : pos))
    );
    setIsEditing(false);
  };

  const cancelEdit = () => {
    setEditedPosition({ ...positionProp });
    setIsEditing(false);
  };

  useEffect(() => {
    if (!isEditing) {
      setNewPositionsProp((prevPositions) =>
        prevPositions.map((pos) =>
          pos === positionProp ? editedPosition : pos
        )
      );
    }
  }, [isEditing, positionProp, editedPosition]);

  return (
    <div className={Style.PositionContainer}>
      {isEditing ? (
        <>
          <div className={Style.EditPositionField}>
            <label>Naziv pozicije:</label>
            <input
              type="text"
              name="positionName"
              value={editedPosition.positionName}
              onChange={handleInputChange}
            />
          </div>
          <div className={Style.EditPositionField}>
            <label>Bruto 2 plaća (EUR):</label>
            <input
              type="number"
              name="positionSalary"
              value={editedPosition.positionSalary}
              onChange={handleInputChange}
            />
          </div>
          <div className={Style.EditPositionField}>
            <label>Postotak radnog vremena (%):</label>
            <input
              type="number"
              name="positionPercentage"
              value={editedPosition.positionPercentage}
              onChange={handleInputChange}
            />
          </div>
          <div className={Style.EditPositionField}>
            <label>Vrijeme trajanja rada (mj.):</label>
            <input
              type="number"
              name="expectedWorkTimeDurationInMonths"
              value={editedPosition.expectedWorkTimeDurationInMonths}
              onChange={handleInputChange}
            />
          </div>
          <div className={Style.EditButtonsContainer}>
            <button className={Style.SaveButton} onClick={saveChanges}>
              Spremi
            </button>
            <button className={Style.CancelButton} onClick={cancelEdit}>
              Odustani
            </button>
          </div>
        </>
      ) : (
        <>
          <div className={Style.PositionValue} style={{ fontWeight: "bold" }}>
            {positionProp.positionName}
          </div>
          <div className={Style.PositionValue}>
            Bruto 2 plaća: {formatNumber(positionProp.positionSalary)}EUR
          </div>
          <div className={Style.PositionValue}>
            Postotak radnog vremena: {positionProp.positionPercentage}%
          </div>
          <div className={Style.PositionValue}>
            Vrijeme trajanja rada:{" "}
            {positionProp.expectedWorkTimeDurationInMonths} mj.
          </div>
          <div className={Style.ButtonContainer}>
            <button
              className={Style.EditPositionButton}
              onClick={() => setIsEditing(true)}
            >
              Uredi
            </button>
            <button
              className={Style.RemovePositionButton}
              onClick={removePosition}
            >
              Ukloni
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Position;
